<div class="layout horizontal center middle">
  <!-- 
  SE AUTENTICATO
  -->
  <div *ngIf="securityDataService.isAuthenticated()" class="layout horizontal end middle" [matMenuTriggerFor]="menu"
       style="cursor: pointer; margin-inline-end: 8px;">
    <!-- 
    ICONA 
    -->
    <div style="height: 40px; width: 30px;" class="layout horizontal center middle">
      <mat-icon svgIcon="account-circle"></mat-icon>
    </div>
    <!-- 
    USER FIRST NAME AND LAST NAME or USERNAME
    -->
    <div style="font-size: large; white-space: nowrap; margin-bottom: 2px; max-width: 200px; overflow: hidden; text-overflow: ellipsis;">
      <!-- USER FIRST NAME AND LAST NAME -->
      <ng-container *ngIf="securityDataService.userProfile && securityDataService.userProfile.name">
       {{securityDataService.userProfile.name}}
      </ng-container>
      <!-- USERNAME -->
      <ng-container *ngIf="securityDataService.userProfile && !securityDataService.userProfile.name">
       {{securityDataService.userProfile.username}}
     </ng-container>
    </div>
  </div>
  <mat-menu #menu="matMenu">
    <ng-container>
      <button mat-menu-item (click)="openChangePasswordDialog()">
        <mat-icon>security</mat-icon><span>{{ 'CHANGE_PASSWORD.TITLE' | translate }}</span>
      </button>
      <button mat-menu-item (click)="securityDataService.logout()">
        <mat-icon>logout</mat-icon><span>{{ 'LOGOUT' | translate }}</span>
      </button>
    </ng-container>
  </mat-menu>
  <!-- 
  SE NON AUTENTICATO
  -->
  <ng-container *ngIf="!securityDataService.isAuthenticated() && !appearance.publicArea.header.profileSection.hideIfNotAuthenticated">
    <!-- 
    LOGIN BUTTON
    -->
    <app-button [label]="'LOGIN.TITLE' | translate"
                [icon]="'login'" 
                [action]="navigateToLogin"
                [settings]="{bgColor: 'transparent', 
                             fontColor: appearance.publicArea.header.fontColor}">
    </app-button>
  </ng-container>
</div>

